/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Lot_Detail_Label_ExpiryInputs */

const vi_product_lot_detail_label_expiry = /** @type {(inputs: Product_Lot_Detail_Label_ExpiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hạn sử dụng`)
};

/**

* @param {Product_Lot_Detail_Label_ExpiryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_lot_detail_label_expiry = /** @type {((inputs?: Product_Lot_Detail_Label_ExpiryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Lot_Detail_Label_ExpiryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_lot_detail_label_expiry(inputs)
});